/** 配列データを CSV テキスト（UTF-8 BOM 付き）に変換してダウンロードさせる */

/** CSV セル 1 個をエスケープ（カンマ・改行・ダブルクォート対応） */
function escapeCell(value: unknown): string {
  const s = value == null ? '' : String(value);
  if (/[",\r\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/** ヘッダ行と各行データから CSV テキストを生成する */
export function toCsv(headers: string[], rows: (string | number | null | undefined)[][]): string {
  const lines = [headers.map(escapeCell).join(',')];
  for (const row of rows) {
    lines.push(row.map(escapeCell).join(','));
  }
  return lines.join('\r\n');
}

/** CSV テキストを UTF-8 BOM 付きで Blob 化し、ファイルとしてダウンロードする */
export function downloadCsv(filename: string, csvText: string): void {
  const blob = new Blob(['﻿' + csvText], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
